import { useProfileQuery } from "@/hooks/profile/useProfileQuery";
import { SocioScheduleView } from "./SocioScheduleView";
import { ProfesorScheduleView } from "./ProfesorScheduleView";
import { Loader2 } from "lucide-react";

export const MisHorarios = () => {
  const { data: profile, isLoading } = useProfileQuery();

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Loader2 className="w-6 h-6 animate-spin text-primary" />
      </div>
    );
  }

  if (!profile) return null;

  if (profile.role === "profesor") {
    return <ProfesorScheduleView profile={profile} />;
  }

  return <SocioScheduleView profile={profile} />;
};
